import { createFormState, required } from "redux-freeform";
import { emailFormatValidators } from "../../../util/emailValidators";

const formConfig = {
  email: {
    validators: [required(), ...emailFormatValidators]
  }
};

export const { reducer, mapStateToProps, mapDispatchToProps } = createFormState(
  formConfig
);
